export default "__VITE_ASSET__74ae0146__"